import { DomainBase } from "./DomainBase";

  export class ZoneClass extends DomainBase {
    constructor() {
        super();
        this.name = '';
        this.otherLanguageName = '';
        this.branch = null;
        this.id= 1;
        this.branchID =  null;
    }
}
         